import {Component, Input, OnInit} from "@angular/core";
import {PortalService} from "../../../services/portal.service";
import {ElementService} from "../../../services/element.service";
import {FoerdermittelcheckAnfrage} from "../../anfrage/foerdermittelcheck.anfrage";

@Component({
  selector: 'app-honeypot',
  templateUrl: './honeypot.component.html',
})

export class HoneypotComponent implements OnInit {

  /**
   * get foerdermittelcheck anfrage
   */
  @Input() anfrage: FoerdermittelcheckAnfrage;

  /**
   * jump to element with specific id
   */
  @Input() clickTarget: string = null;

  /**
   * textkeyprefix for all texts
   */
  textkeyPrefix: string = 'foerdermittelcheck.ergebnis.honeypot';

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * holds how many images to show
   */
  countTeaserImages: any[] = [1, 2, 3];

  /**
   * set to true if no programs available
   */
  noPrograms: boolean;

  /**
   * Defines the breakpoint for the medium viewport.
   */
  mediumBreakpoint: number;

  /**
   * Defines the breakpoint for the large viewport.
   */
  largeBreakpoint: number;

  /**
   * constructor
   */
  constructor(protected elementService: ElementService, private portalService: PortalService) {}

  ngOnInit(): void {
    this.internalPortal = this.portalService.isInternalPortal();

    //show less teaser images if no programs available
    if(this.anfrage?.programs?.length === 0) {
      this.countTeaserImages = [1];
      this.noPrograms = true;
    }

    this.initBreakpoints();
  }

  /**
   * jump to lead/download module after click on button
   */
  onClickToLeadModule() {
    this.elementService.scrollToElement(document.querySelector('#' + this.clickTarget));
  }

  /**
   * initialize different breakpoints in case we have or do not have programs
   */
  initBreakpoints(): void {
    if(this.noPrograms) {
      this.mediumBreakpoint = 8;
      this.largeBreakpoint = 7;
    }
    else {
      this.mediumBreakpoint = 4;
      this.largeBreakpoint = 4;
    }
  }

}
